import headingStyles from './Heading.module.css';

import AnchorLink from "./AnchorLink";

const Heading = ({heading,description='',button={icon:"",title:"",href:"",target:"_self"}}) => {

    return (
        <div className="d-flex flex-column position-relative">
            <div className={headingStyles["heading-broder"]}>
                <h2>
                    {heading || ''}
                </h2>
            </div>
            {description &&
            <div className={`${headingStyles["heading-content"]}`}>
                <p>{description}</p>
            </div>
            }
            
            {button.title.length > 0 &&
            <div className={headingStyles["heading-button"]}>
                <AnchorLink 
                    target={button.target}
                    icon={button.icon}
                    title={button.title}
                    href={button.href}
                />
            </div>
            }
        </div>
    );
};

export default Heading;